/* -----------------------------------------------------------------------
Terms and Conditions Template
-----------------------------------------------------------------------
Links (ctrl + click to follow):
Contentful Entries: https://app.contentful.com/spaces/n3ohnvkomoi9/entries?id=gQ9DJd1JJdYbFCKl&contentTypeId=basicRichText&order.fieldId=updatedAt&order.direction=descending&displayedFieldIds=W0lZ7lOacNy1fZAp
Content Model: https://app.contentful.com/spaces/n3ohnvkomoi9/content_types/basicRichText/fields
GraphQL Explorer: http://localhost:8000/___graphql?query=query%20MyQuery%20%7B%0A%20%20contentfulBasicRichText%20%7B%0A%20%20%20%20%0A%20%20%7D%0A%7D%0A
-----------------------------------------------------------------------
Supported components: See "../components/solutions/index"
Slug: /...
-------------------------------------------------------------------------*/

import React from "react";
import { graphql } from "gatsby";
import HTMLWrapper from "../components/basic/HTMLWrapper";
import documentToReactComponents from "../components/util/documentToReactComponents";

import Layout from "../components/layout";
import Margin from "../components/basic/layouts/Section";
import Helmet from "../components/basic/Helmet";
import Text from "../components/basic/Text";
import theme from "../styles/theme";

const { colors } = theme;

const Page = ({ location, data }) => {
	const { contentfulBasicRichText } = data;

	const content = contentfulBasicRichText.richText;
	const title = contentfulBasicRichText.title;
	const isSearchable = contentfulBasicRichText.isSearchable

	return (
		<Layout location={location}>
			<Helmet
				pageTitle={title}
				description={title}
				location={location}
				updatedAt="2020-02-01T08:00:09.074Z"
				noIndex={isSearchable === false}
			/>
			<Margin maxWidth="850px">
				<Text component="h1">{title}</Text>
				<HTMLWrapper oneColumnList discColor={colors.grayscale.main}>
					{documentToReactComponents(content, {
						replaceNode: { "heading-1": "heading-3", "heading-2": "heading-4" },
						noCaptions: true,
					})}
				</HTMLWrapper>
			</Margin>
		</Layout>
	);
};

export default Page;

export const termsConditionsQuery = graphql`
	query termsConditionsQuery($contentful_id: String!) {
		contentfulBasicRichText(contentful_id: { eq: $contentful_id }) {
			contentful_id
			title
			isSearchable
			richText {
				#json
				raw
				references {
					... on ContentfulAsset {
						...AssetFragment
					}
				}
			}
		}
	}
`;
